import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        position: "relative",
        display: "flex",
        padding: "0.75rem",
        borderRadius: ".25rem",
        border: `1px solid ${theme.colors.gray[2]}`,
        boxShadow: theme.shadows.xs,
        alignItems: "center",
        gap: "0.75rem",
    },
    association: {
        display: "flex",
        width: "100%",
    },
    icon: {
        minWidth: "2.5rem",
        minHeight: "2.5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "1.5rem",
        backgroundColor: theme.colors.violet[1],
        color: theme.colors.violet[8],
        fontSize: "1rem",
        lineHeight: "normal",
    },
    titleWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    name: {
        color: theme.colors.violet[7],
        fontSize: ".875rem",
        fontWeight: 500,
        lineHeight: 1.5,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    subtitle: {
        color: theme.colors.gray[7],
        fontSize: ".75rem",
        lineHeight: 1.5,
    },
}))
